// extracted by mini-css-extract-plugin
export default {"student":"styles_student__0M94R","student-attendance-modal":"styles_student-attendance-modal__RUd0p"};